// src/components/ui/Input.jsx
import React from 'react';

/**
 * Reusable Input field component that now accepts standard input attributes
 * and includes optional label support.
 */
function Input({
  type = 'text',
  placeholder,
  value,
  onChange,
  className = '',
  disabled = false,
  // --- Added props ---
  label,      // Optional label text
  id,         // Input ID (used for label 'for' attribute)
  name,       // Input name attribute (crucial for form handling)
  required,   // Standard HTML required attribute
  autoFocus,  // Standard HTML autoFocus attribute
  minLength,  // Standard HTML minLength attribute
  // Add other standard input attributes as needed (e.g., pattern, maxLength)
  ...rest // Pass any other miscellaneous props
}) {
  // Use the provided id or fallback to the name for the label's 'htmlFor'
  const inputId = id || name;

  return (
    // Wrap input and optional label
    <div className="w-full">
      {/* Render label if provided */}
      {label && (
        <label
          htmlFor={inputId} // Link label to input
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
          {/* Add asterisk if required */}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        // --- Pass down standard attributes ---
        id={inputId}
        name={name} // Pass the name attribute
        type={type}
        placeholder={placeholder}
        value={value} // Controlled component value
        onChange={onChange} // Handler for changes
        className={`w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50 ${className}`}
        disabled={disabled}
        required={required} // Pass required attribute
        autoFocus={autoFocus} // Pass autoFocus attribute
        minLength={minLength} // Pass minLength attribute
        {...rest} // Pass any other remaining props
      />
    </div>
  );
}

export default Input;
